import {
  createCoaching,
  getCoachingVertragRef,
  getCoachingVoucherRef,
  getGueltigkeit,
  patchCoaching,
} from './coaching'
import {
  createMassnahme,
  getMassnahmeTbFields,
  getMassnahmeUeBudget,
  listMassnahmen,
  listMassnahmenFull,
  updateMassnahme,
} from './massnahmen'
import { getPersonRecords } from './person'
import { createDokument, patchDokument } from './dokumente'

export const AZAV_SUBTYPE = {
  getPersonRecords,
  getGueltigkeit,
  createCoaching,
  patchCoaching,
  getCoachingVertragRef,
  getCoachingVoucherRef,
  listMassnahmenFull,
  createMassnahme,
  updateMassnahme,
  getMassnahmeUeBudget,
  listMassnahmen,
  getMassnahmeTbFields,
  createDokument,
  patchDokument,
}
